import { EmployeeStatusesHelper } from '@/helpers/employee-statuses.helper';

/**
 * @template S, R
 * @typedef {import('vuex').GetterTree<S, R>} GetterTree<S, R>
 */
/**
 * @typedef {import('@/store/root.state').RootState} RootState
 * @typedef {import('./employees-list.state').EmployeesListState} EmployeesListState
 */

/** @type {GetterTree<EmployeesListState, RootState>} */
export const employeesListGetters = {
  employeesFiltered: (state) => state.employees,
  statusFilter: ({ filters: { statuses } }, { statusFilterOptions }) => {
    if (statuses || !statusFilterOptions.length) return statuses || [];

    return EmployeeStatusesHelper.filterDefaultStatuses(statusFilterOptions);
  },
  statusFilterOptions: ({ allEmployeesForOptions }) => EmployeeStatusesHelper.getStatusesFromEmployees(allEmployeesForOptions),
};
